import { atom, useAtom } from "jotai";
import { Permission } from "src/api/types";
import {
  checkHasAuthToken,
  getAuthToken,
  removeAuthToken,
  setAuthToken,
  getAuthUserInfo,
  setAuthUserInfo,
  removeAuthUserInfo,
} from "../api/token-util";

const authorizationAtom = atom(checkHasAuthToken());
export default function useAuth() {
  const [isAuthorized, setAuthorized] = useAtom(authorizationAtom);
  const permissions: Permission[] = getAuthUserInfo()?.permissions;
  console.log('permissions', permissions);
  const permissionNames = permissions?.map((item) => item.name);
  const checkPermission = (names: string[]) => {
    return names.every((item) => permissionNames?.includes(item));
  };

  return {
    setToken: setAuthToken,
    getToken: getAuthToken,
    getCurrrentUser: getAuthUserInfo,
    setCurrentUser: setAuthUserInfo,
    isAuthorized,
    authorize(token: string) {
      setAuthToken(token);
      setAuthorized(true);
    },
    unauthorize() {
      setAuthorized(false);
      removeAuthUserInfo();
      removeAuthToken();
    },
    checkPermission,
  };
}
